var _classCallCheck = require("/home/masoud021/Project/campaign-url-builder/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/masoud021/Project/campaign-url-builder/node_modules/@babel/runtime/helpers/createClass");

/*!
 * bulma-toast 1.5.0 
 * (c) 2018-present @rfoel <rafaelfr@outlook.com> 
 * Released under the MIT License.
 */
(function (a, b) {
  'object' == typeof exports && 'undefined' != typeof module ? b(exports) : 'function' == typeof define && define.amd ? define(['exports'], b) : b(a.bulmaToast = {});
})(this, function (a) {
  'use strict';

  function b() {
    g = {
      noticesTopLeft: i.createElement('div'),
      noticesTopRight: i.createElement('div'),
      noticesBottomLeft: i.createElement('div'),
      noticesBottomRight: i.createElement('div'),
      noticesTopCenter: i.createElement('div'),
      noticesBottomCenter: i.createElement('div'),
      noticesCenter: i.createElement('div')
    };

    for (var _a in g.noticesTopLeft.setAttribute('style', 'width:100%;z-index:99999;position:fixed;pointer-events:none;display:flex;flex-direction:column;padding:15px;'.concat("left:0;top:0;text-align:left;align-items:flex-start;")), g.noticesTopRight.setAttribute('style', 'width:100%;z-index:99999;position:fixed;pointer-events:none;display:flex;flex-direction:column;padding:15px;'.concat("right:0;top:0;text-align:right;align-items:flex-end;")), g.noticesBottomLeft.setAttribute('style', 'width:100%;z-index:99999;position:fixed;pointer-events:none;display:flex;flex-direction:column;padding:15px;'.concat("left:0;bottom:0;text-align:left;align-items:flex-start;")), g.noticesBottomRight.setAttribute('style', 'width:100%;z-index:99999;position:fixed;pointer-events:none;display:flex;flex-direction:column;padding:15px;'.concat("right:0;bottom:0;text-align:right;align-items:flex-end;")), g.noticesTopCenter.setAttribute('style', 'width:100%;z-index:99999;position:fixed;pointer-events:none;display:flex;flex-direction:column;padding:15px;'.concat("top:0;left:0;right:0;text-align:center;align-items:center;")), g.noticesBottomCenter.setAttribute('style', 'width:100%;z-index:99999;position:fixed;pointer-events:none;display:flex;flex-direction:column;padding:15px;'.concat("bottom:0;left:0;right:0;text-align:center;align-items:center;")), g.noticesCenter.setAttribute('style', 'width:100%;z-index:99999;position:fixed;pointer-events:none;display:flex;flex-direction:column;padding:15px;'.concat("top:0;left:0;right:0;bottom:0;flex-flow:column;justify-content:center;align-items:center;")), g) {
      i.body.appendChild(g[_a]);
    }

    h = {
      "top-left": g.noticesTopLeft,
      "top-right": g.noticesTopRight,
      "top-center": g.noticesTopCenter,
      "bottom-left": g.noticesBottomLeft,
      "bottom-right": g.noticesBottomRight,
      "bottom-center": g.noticesBottomCenter,
      center: g.noticesCenter
    }, f = !0;
  }

  function c(a) {
    f || b();
    var c = Object.assign({}, e, a);
    var d = new j(c),
        g = h[c.position] || h[e.position];
    g.appendChild(d.element);
  }

  function d(a) {
    for (var _b in g) {
      var _a2 = g[_b];

      _a2.parentNode.removeChild(_a2);
    }

    i = a, b();
  }

  var e = {
    message: 'Your message here',
    duration: 2e3,
    position: 'top-right',
    closeOnClick: !0,
    opacity: 1
  };
  var f = !1,
      g = {},
      h = {},
      i = document;

  var j =
  /*#__PURE__*/
  function () {
    function j(a) {
      var _this = this;

      _classCallCheck(this, j);

      this.element = i.createElement('div'), this.opacity = a.opacity, this.type = a.type, this.animate = a.animate, this.dismissible = a.dismissible, this.closeOnClick = a.closeOnClick, this.message = a.message, this.duration = a.duration, this.pauseOnHover = a.pauseOnHover;
      var b = "width:auto;pointer-events:auto;display:inline-flex;opacity:".concat(this.opacity, ";"),
          c = ['notification'];

      if (this.type && c.push(this.type), this.animate && this.animate.in && (c.push("animated ".concat(this.animate.in)), this.onAnimationEnd(function () {
        return _this.element.classList.remove(_this.animate.in);
      })), this.element.className = c.join(' '), this.dismissible) {
        var _a3 = i.createElement('button');

        _a3.className = 'delete', _a3.addEventListener('click', function () {
          _this.destroy();
        }), this.element.insertAdjacentElement('afterbegin', _a3);
      } else b += 'padding: 1.25rem 1.5rem';

      this.closeOnClick && this.element.addEventListener('click', function () {
        _this.destroy();
      }), this.element.setAttribute('style', b), 'string' == typeof this.message ? this.element.insertAdjacentHTML('beforeend', this.message) : this.element.appendChild(this.message);
      var d = new k(function () {
        _this.destroy();
      }, this.duration);
      this.pauseOnHover && (this.element.addEventListener('mouseover', function () {
        d.pause();
      }), this.element.addEventListener('mouseout', function () {
        d.resume();
      }));
    }

    _createClass(j, [{
      key: "destroy",
      value: function destroy() {
        var _this2 = this;

        this.animate && this.animate.out ? (this.element.classList.add(this.animate.out), this.onAnimationEnd(function () {
          return _this2.removeChild(_this2.element);
        })) : this.removeChild(this.element);
      }
    }, {
      key: "removeChild",
      value: function removeChild(a) {
        a.parentNode && a.parentNode.removeChild(a);
      }
    }, {
      key: "onAnimationEnd",
      value: function onAnimationEnd() {
        var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
        var b = {
          animation: 'animationend',
          OAnimation: 'oAnimationEnd',
          MozAnimation: 'mozAnimationEnd',
          WebkitAnimation: 'webkitAnimationEnd'
        };

        for (var _c in b) {
          if (this.element.style[_c] !== void 0) {
            this.element.addEventListener(b[_c], function () {
              return a();
            });
            break;
          }
        }
      }
    }]);

    return j;
  }();

  var k =
  /*#__PURE__*/
  function () {
    function k(a, b) {
      _classCallCheck(this, k);

      this.timer, this.start, this.remaining = b, this.callback = a, this.resume();
    }

    _createClass(k, [{
      key: "pause",
      value: function pause() {
        window.clearTimeout(this.timer), this.remaining -= new Date() - this.start;
      }
    }, {
      key: "resume",
      value: function resume() {
        this.start = new Date(), window.clearTimeout(this.timer), this.timer = window.setTimeout(this.callback, this.remaining);
      }
    }]);

    return k;
  }();

  a.toast = c, a.setDoc = d, Object.defineProperty(a, '__esModule', {
    value: !0
  });
});